import { useState, useEffect, useCallback } from "react";
import { dbGet, dbSet } from "@/lib/db";
import { SK } from "@/lib/constants";

export function useZones() {
  const [zones, setZones] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dbGet<string[]>(SK.ZONES).then((z) => {
      setZones(z ?? []);
      setLoading(false);
    });
  }, []);

  const persist = useCallback((next: string[]) => {
    setZones(next);
    dbSet(SK.ZONES, next);
  }, []);

  const addZone = useCallback(
    (name: string) => {
      if (!zones.includes(name)) persist([...zones, name]);
    },
    [zones, persist]
  );

  const removeZone = useCallback(
    (name: string) => {
      persist(zones.filter((z) => z !== name));
    },
    [zones, persist]
  );

  const setAllZones = useCallback(
    (z: string[]) => persist(z),
    [persist]
  );

  return { zones, loading, addZone, removeZone, setAllZones };
}
